import { type DateRange } from "@mui/x-date-pickers-pro";
import { type DateTime } from "luxon";
import { createContext } from "react";

import { type MachineSelectionWithChecked } from "../../types";

interface ReportingContextProps {
	selectedDateRange: DateRange<DateTime>;
	selectedShortcut: string | null;
	prevDateRange: DateRange<DateTime> | null;
	prevShortcut: string | null;

	setSelectedDateRange: (
		dateRange: DateRange<DateTime>,
		shortcut: string | null,
		prevDateRange: DateRange<DateTime> | null,
		prevShortcut: string | null,
	) => void;
	timezone: string;
	sites: string[];
	isMetric: boolean;
	isPlannedProductionEnabled: boolean;
	usePlannedProduction: boolean;
	setUsePlannedProduction: (value: boolean) => void;
	machines: MachineSelectionWithChecked[];
	setMachines: (machines: MachineSelectionWithChecked[]) => void;
}

const initialState: ReportingContextProps = {
	selectedDateRange: [null, null],
	selectedShortcut: null,
	prevDateRange: null,
	prevShortcut: null,
	setSelectedDateRange: () => {},
	timezone: "",
	sites: [],
	isMetric: false,
	isPlannedProductionEnabled: false,
	usePlannedProduction: false,
	setUsePlannedProduction: () => {},
	machines: [],
	setMachines: () => {},
};

export const ReportingContext = createContext<ReportingContextProps>(initialState);
